import { URL_CONFIG } from "~~/shared/utils/url.const"

export const CONTENT_TYPES = {
  PODCAST: "podcast",
  VIDEO: "video",
  ARTICLE: "article",
  PODCASTS: "podcasts",
  VIDEOS: "videos",
  ARTICLES: "articles",
  TAKE_FIVE_DAILY :"take-five-daily",
  NEWSROOM: "press-releases",
  FAQS: "faqs",
  PRODUCT:"product",
  FAVORITE:"favorite",
  UNFAVORITE:"unfavorite",
  MARKETINGAD:"marketing-ads",
  CLOSERLOOKTEXT: "Why Ours",
  CLOSERLOOKBUYNOW: "Buy Now",
  CLOSERLOOKINGREDIENTINFORMATION: "Ingredients Information",
  CLOSERLOOKTSUMMARY: "Summary & Comparison",
  CLOSERLOOKREVIEWS: "Reviews",
  CLOSERLOOKWARNINGS: "Warnings",
  CLOSERLOOKDETAILS: "Details",
  CLOSERLOOKBACKTOTOP: "Back to Top",
  CLOSERLOOKFAQS: "FAQs"
} as const;

export const TAGS_ARRAY = [
  "Sports Performance",
  "Wellness Trends",
  "Partner"
];

export const CATEGORY_DETAILS = [
  {
    icon: 'inventory',
    categoryName: 'Shipping',
    url: URL_CONFIG.FAQS_SHIPPING,
    articleCount: 0,
    builderIoKey: 'SHIPPING'
  },
  {
    icon: 'arrow-right-arrow-left',
    categoryName: 'Returns & Exchanges',
    url: URL_CONFIG.FAQS_RETURNS_AND_EXCHANGES,
    articleCount: 0,
    builderIoKey: 'RETURNS'
  },
  {
    icon: 'capsules',
    categoryName: 'Supplements',
    url: URL_CONFIG.FAQS_SUPPLEMENTS,
    articleCount: 0,
    builderIoKey: 'SUPPLEMENTS'
  },
  {
    icon: 'vial',
    categoryName: 'Tests',
    url: URL_CONFIG.FAQS_TESTS,
    articleCount: 0,
    builderIoKey: 'TESTS'
  },
  {
    icon: 'user-circle',
    categoryName: 'Account & Subscriptions',
    url: URL_CONFIG.FAQS_ACCOUNTS_SUBSCRIPTIONS,
    articleCount: 0,
    builderIoKey: 'ACCOUNT'
  },
  {
    icon: 'head-side-brain',
    categoryName: 'Other Questions',
    url: URL_CONFIG.FAQS_OTHER_QUESTIONS,
    articleCount: 0,
    builderIoKey: 'OTHER'
  },
  {
    icon: 'coins',
    categoryName: 'Rewards',
    url: URL_CONFIG.FAQS_REWARDS,
    articleCount: 0,
    builderIoKey: 'REWARDS'
  },
  {
    icon: 'pennant',
    categoryName: 'Ambassadors',
    url: URL_CONFIG.FAQS_AMBASSADORS,
    articleCount: 0,
    builderIoKey: 'AMBASSADORS'
  },
  {
    icon: 'gift-card',
    categoryName: 'Referrals',
    url: URL_CONFIG.FAQS_REFERRALS,
    articleCount: 0,
    builderIoKey: 'REFERRALS'
  }
]

export const ENTITY_TYPE = {
  TAIA: "Taia",
  QUIZ: "Quiz",
  HEALTH_TEST: "Health Test"
}

export const PRODUCT_CONTENT = {
 PRODUCT_STORE_DATA:"productStoreData",
 INGREDIENTS :"Ingredients",
 HEALTH_NEEDS :"Health Needs",
 SUPPLEMENTS_TESTS:"Supplements",
 SUPPLEMENTS :"Supplements",
 BY_HEALTH_NEED:"by-health-need/",
 QUICK_ORDER:"Quick Order",
 THORNE_PRODUCT_STACKS:"Thorne Product Stacks",
 PRODUCT_NOT_FOUND:"Product not found"
}
export interface SubscriptionOption {
  value: number
  label: string
}

export const TEST_SUBSCRIPTION_OPTIONS: SubscriptionOption[] = [
  { value: 30, label: 'Monthly' },
  { value: 90, label: 'Quarterly' },
  { value: 182, label: 'Semi-Annual' }
]

export const DEFAULT_SUBSCRIPTION_OPTIONS: SubscriptionOption[] = [
  { value: 14, label: 'Every 2 weeks' },
  { value: 30, label: 'Monthly (most common)' },
  { value: 45, label: 'Every 45 days' },
  { value: 60, label: 'Every 2 months' },
  { value: 90, label: 'Every 3 months' },
  { value: 120, label: 'Every 4 months' }
]
